module.exports = "<app-user-messages></app-user-messages>\r\n<app-spinner></app-spinner>\r\n<router-outlet></router-outlet>\r\n"